import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { VAlert } from 'vuetify/lib';

type Props = {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  header?: string;
  highlighted?: boolean;
  link?: boolean;
  href?: string;
  target?: string;
  hideBulletPoint?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicInfo',
  props: {
    label: null,
    value: null,
    header: null,
    highlighted: { type: Boolean },
    link: { type: Boolean },
    href: null,
    target: null,
    hideBulletPoint: { type: Boolean }
  },
  emits: ['click:label', 'click:value'],
  setup(__props: any) {

const props = __props as {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  header?: string;
  highlighted?: boolean;
  link?: boolean;
  href?: string;
  target?: string;
  hideBulletPoint?: boolean;
};





const wrapperComponent = computed(() => (props.highlighted ? VAlert : 'div'));
const textComponent = computed(() => (props.link ? 'a' : 'span'));

return { __sfc: true,props, wrapperComponent, textComponent }
}

})